import { render, staticRenderFns } from "./WorkoutSplitEditExerciseMulti.vue?vue&type=template&id=2cb4c007&scoped=true"
import script from "./WorkoutSplitEditExerciseMulti.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitEditExerciseMulti.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitEditExerciseMulti.vue?vue&type=style&index=0&id=2cb4c007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4c007",
  null
  
)

export default component.exports